import React, {FC} from "react"
import * as PropTypes from "prop-types"

import History from "@irati/utils/history"
import {RewardValueTypes} from "./DistributeRewardStep1"
import {DistributePayload, DistributeOnChange} from "../../../containers/AdminReward/DistributeReward"
import {StepNames} from "../../../enums"
import DistributeRewardSummaryStep1 from "./DistributeRewardSummaryStep1"
import DistributeRewardSummaryStep2 from "./DistributeRewardSummaryStep2"

interface Props {
  onSubmit: () => void,
  assignReward: RewardValueTypes,
  payload: DistributePayload,
  onPayloadChange: DistributeOnChange
}

const DistributeRewardSummary: FC<Props> = ({
  onSubmit,
  assignReward,
  payload,
  onPayloadChange
}, context) => {


  const handlePointsPerUser = (pointsPerUser: number) => {
    onPayloadChange({...payload, pointsPerUser})
  }

  const handlePrevStep = () => {
    if (location.pathname.includes(StepNames.Confirm)) {
      History.push(`/flexi-assign/${StepNames.Message}`, context)
    } else {
      History.push(`/flexi-assign/${StepNames.Recipients}`, context)
    }
  }

  const buttonText = assignReward === RewardValueTypes.Managers ? "wallet.reward.admin.btn.assign" : "wallet.reward.admin.btn.sendReward"
  const isConfirmStep = location.pathname.includes(StepNames.Confirm)

  return (
    isConfirmStep ?
      <DistributeRewardSummaryStep2
        onSubmit={onSubmit}
        payload={payload}
        handlePrevStep={handlePrevStep}
        buttonText={buttonText} /> :
      <DistributeRewardSummaryStep1
        payload={payload}
        handlePrevStep={handlePrevStep}
        handlePointsPerUser={handlePointsPerUser} />
  )
}

DistributeRewardSummary.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default DistributeRewardSummary
